var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('Form',{key:"AddContract",staticClass:"float-left",attrs:{"name":'AddContract',"loadFormData":true,"isEditing":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }